export default __webpack_public_path__ + "static/media/Sume_EligeGanadores.94f7e0d3.png";